export default "__VITE_ASSET__BLVNWW72__"